import { useState } from "react";
import "./catalogue.css";
import Container from "../../components/Container/Container";
import CustomButton from "../../components/commons/CustomBtn";
import PromoteursList from "./components/PromoteursList";
import { useSelector } from "react-redux";

const Catalogue = () => {
  const [activeOnglet, setActiveOnglet] = useState("promoteurs");
  const { length } = useSelector((state) => state.promoteursReducer);

  return (
    <Container>
      <div className="d-flex gap10">
        <CustomButton
          onClick={() => setActiveOnglet("promoteurs")}
          label="Promoteurs"
          contentLength1={length}
          contentType1="Promoteurs"
          contentLengthClass={`${"regular fs11 pink"}`}
          buttonClass={`${"bg-white radiusTop5 px-20 py-10 "}`}
          labelClass={`${"pink fs16 semibold text-capitalize text-start"}`}
        />
      </div>
      <PromoteursList />
    </Container>
  );
};

export default Catalogue;
